import { render, staticRenderFns } from "./GoodLuck.vue?vue&type=template&id=1d1dd178&scoped=true&"
import script from "./GoodLuck.vue?vue&type=script&lang=js&"
export * from "./GoodLuck.vue?vue&type=script&lang=js&"
import style0 from "./GoodLuck.vue?vue&type=style&index=0&id=1d1dd178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1dd178",
  null
  
)

export default component.exports